export function trackMatomoEvent(event) {
  window._paq.push(['trackEvent', event]);
}
